import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { ManPowersService } from 'src/app/services/man-powers.service';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationType } from 'src/app/models/notification.message';
import { UserService } from 'src/app/services/user.service';
import { ManPowerDto } from 'src/app/models/ManPowerDto';
//import { Profile } from 'src/app/models/Profile';
import { ApiResponseObject } from 'src/app/models/responses/api-response-object';
import { Profile } from 'src/app/models/profile';
import { ManpowerrecruitmentService } from 'src/app/services/manpowerrecruitment.service';
import { OnboardNewHireVM } from 'src/app/models/requests/OnboardNewHireVM';
import { LocationDto } from 'src/app/models/LocationDto';
import { FunctionDto } from 'src/app/models/FunctionDto';
import { LocationsService } from 'src/app/services/locations.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { DepartmentsService } from 'src/app/services/departments.service';
import { DepartmentDto } from 'src/app/models/DepartmentDto';

@Component({
  selector: 'app-newhireonboarding',
  templateUrl: './newhireonboarding.component.html',
  styleUrls: ['./newhireonboarding.component.css']
})
export class NewhireonboardingComponent implements OnInit {

  recordId = '';

  // Prefilled from manpower
  role = '';
  func = '';
  location = '';

  // To be filled manually
  name = '';
  lineManager = '';
  hrbp = '';
  startDate = '';
  email = '';
  phone = '';
  notes : string = '';

  // Dropdown data
  managers: Profile[] = [];
  hrbps: Profile[] = [];
  Departments:DepartmentDto[]=[];
    Locations:LocationDto[]=[];

  constructor(
    private route: ActivatedRoute,
    private manPowerService: ManPowersService,
    private notification: NotificationService,
    private userService: UserService,
    private mprecuitmentservice: ManpowerrecruitmentService,
    private router: Router,
    private locationService: LocationsService,
    private departmentService: DepartmentsService


  ) {
    const nav = this.router.getCurrentNavigation();
    this.notes = nav?.extras.state?.['note'];
    if(this.notes != null || this.notes !='' )  {
    localStorage.setItem('Note', this.notes)
    }
   
  }

  ngOnInit(): void {
  //   this.recordId = Number(this.route.snapshot.paramMap.get('id'));
   
  //     const hold = localStorage.getItem('Note')
  //     this.notes = hold || ''

  //   if (this.recordId) {
  //     this.loadManpowerRecord(this.recordId);
  //   }

    this.loadManagers();
    this.loadHRBPs();
    this.loadLocations();
    this.loadFunctions();
  }

  loadManpowerRecord(id: number): void {
    
    this.manPowerService.getManPowerbyId(id).subscribe({
      next: (res: ApiResponseObject<ManPowerDto>) => {
        if (res.responseCode === '00' && res.responseData) {

          const record = res.responseData;
          this.role = record.jobTitle;
          this.func = record.requesterFunction;
          this.location = record.location;
        } else {
          this.notification.sendMessage({
            message: res.message || 'Unable to fetch manpower record',
            type: NotificationType.error
          });
        }
      },
      error: (err) => {
        console.error('Error fetching manpower record', err);
        this.notification.sendMessage({
          message: 'Error fetching manpower record',
          type: NotificationType.error
        });
      }
    });
  }

  loadManagers(): void {
    
    this.userService.getManagersUsers().subscribe({
      next: (res: ApiResponseObject<Profile[]>) => {
        if (res.responseCode === '00') {
          this.managers = res.responseData;
           console.log('Managers loaded:', res.data);

        }
      },
      error: (err) => console.error('Error fetching managers', err)
    });
  }

  loadLocations(): void {
    
    this.locationService.getLocations().subscribe({
      next: (res: ApiResponseObject<LocationDto[]>) => {
        if (res.responseCode === '00') {
          this.Locations = res.responseData;
           console.log('Locations loaded:', res.data);

        }
      },
      error: (err) => console.error('Error fetching locations', err)
    });
  }

  loadFunctions(): void {
    
    this.departmentService.getDepartments().subscribe({
      next: (res: ApiResponseObject<DepartmentDto[]>) => {
        if (res.responseCode === '00') {
          this.Departments = res.responseData;
           console.log('Departments loaded:', res.data);

        }
      },
      error: (err) => console.error('Error fetching departments', err)
    });
  }

  loadHRBPs(): void {
    
    this.userService.getHRBPS().subscribe({
      next: (res: ApiResponseObject<Profile[]>) => {
        if (res.responseCode === '00') {
          this.hrbps = res.responseData;
          console.log('HRBP API response:', res);

        }
      },
      error: (err) => console.error('Error fetching HRBPs', err)
    });
  }

onSubmit(): void {
  const onboardingData: OnboardNewHireVM = {
    // manpowerReqId: Number.parseInt(this.recordId),
    name: this.name,
    role: this.role,
    function: this.func,
    lineManager: this.lineManager,
    hrbp: this.hrbp,
    startDate: this.startDate,
    location: this.location,
    email: this.email,
    phone: this.phone,
    notes: this.notes
  };

  this.mprecuitmentservice.onboardNewHire(onboardingData).subscribe({
    next: (data => {
      if (data.responseCode === '00') {
        this.notification.sendMessage({
          message: data.message,
          type: NotificationType.success
        });

        console.debug(`Onboarding created successfully`, data);

        // Reset manual fields only
        this.name = this.lineManager = this.hrbp = this.startDate =
          this.email = this.phone = this.notes = '';
      } else {
        this.notification.sendMessage({
          message: data.message,
          type: NotificationType.error
        });
      }
    }),
    error: ((error: any) => {
      console.error(error);
      this.notification.sendMessage({
        message: error.error?.message || 'Onboarding failed, please try again.',
        type: NotificationType.error
      });
    })
  });

}}
